import { FC } from "react";
import { FormRowProps } from "./types";
import {
  DD_STYLES,
  DT_STYLES,
  FIXED_HEIGHT_ROW_STYLES,
  ROW_GRID_STYLES,
  ROW_SUBTITLE_STYLES,
  SM_LONG_INPUT_STYLES,
} from "../styles";

export const FormRow: FC<React.PropsWithChildren<FormRowProps>> = ({
  labelText,
  labelHtmlFor,
  id,
  children,
  fixedHeight = false,
  subtitle,
  className,
}) => {
  return (
    <div
      className={`${ROW_GRID_STYLES} items-center px-4 text-sm  ${
        fixedHeight ? FIXED_HEIGHT_ROW_STYLES : "py-4"
      } ${className ? "" : "flex-wrap"}`}
      id={id}
    >
      <dt className={DT_STYLES}>
        <label htmlFor={labelHtmlFor}>
          {labelText}
          {subtitle && <p className={ROW_SUBTITLE_STYLES}>{subtitle}</p>}
        </label>
      </dt>

      <dd
        className={`${DD_STYLES} ${
          className ?? `w-full ${SM_LONG_INPUT_STYLES}`
        }`}
      >
        {children}
      </dd>
    </div>
  );
};
